// AddItem adds a new item to the basket.
// In case the item is out of stock or has not enough quantity, the new basket state is returned
// If the item is already present in the basket the qty will be increased.
export const BasketService_AddItemLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_AddItem);
BasketService_AddItemLazy.method =
  "aysa_api.services.basket.v1.BasketService/AddItem" as const;

// Get reduced basket data.
export const BasketService_GetMinimalStateLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_GetMinimalState);
BasketService_GetMinimalStateLazy.method =
  "aysa_api.services.basket.v1.BasketService/GetMinimalState" as const;
